export default "__VITE_ASSET__D8te4KpK__"